window.REGION_ZIPCODES = {
  8765000: "83854",
  8765025: "83814",
  8765050: "83801",
  8765075: "83803",
  8765100: "83535",
  8765150: "83501",
  8766000: "97002",
  8766025: "97010",
  8766050: "97016",
  8766075: "97021",
  8766100: "97029",
  8766150: "97001",
  8766200: "97416",
  8766250: "97407",
  8766300: "97411",
  8766350: "97444",
  8766425: "97415",
  8767000: "98001",
  8767025: "98014",
  8767050: "98022",
  8767075: "98244",
  8767100: "98068",
  8767150: "98326",
  8768000: "93202",
  8768025: "93201",
  8768050: "91310",
  8768075: "91384",
  8768100: "93422",
  8768150: "93401",
  8768200: "93427",
  8768250: "93441",
  8768300: "89003",
  8768350: "95412",
  8768425: "95410",
  8769000: "91901",
  8769025: "91906",
  8769050: "91905",
  8769075: "92259",
  8769100: "92232",
  8769200: "92222",
  8770000: "90091",
  8770025: "90001",
  8770050: "90049",
  8770075: "90265",
  8770100: "92239",
  8770150: "92304",
  8770200: "89019",
  8770250: "86426",
  8770300: "89002",
  8770350: "89001",
  8770425: "89017",
  8770500: "86021",
  8771000: "83605",
  8771025: "83602",
  8771050: "83623",
  8771075: "83314",
  8771100: "83316",
  8771150: "83278",
  8771200: "83227",
  8771250: "83213",
  8771300: "83201",
  8771350: "83212",
  8771425: "83220",
  8771500: "83422",
  8771600: "83802",
  8772000: "89422",
  8772025: "89402",
  8772050: "89406",
  8772075: "89405",
  8772100: "89412",
  8772150: "89418",
  8772200: "89310",
  8772250: "93512",
  8772300: "89010",
  8772350: "89013",
  8772425: "89049",
  8772500: "89311",
  8772600: "95531",
  8773000: "87004",
  8773025: "87001",
  8773050: "87002",
  8773075: "87005",
  8773100: "87011",
  8773150: "87017",
  8773200: "86508",
  8773250: "86502",
  8773300: "85920",
  8773350: "86520",
  8773425: "88231",
  8774000: "85001",
  8774025: "85087",
  8774050: "85135",
  8774075: "85192",
  8774100: "85321",
  8774150: "85360",
  8774200: "85533",
  8774250: "85534",
  8774300: "85540",
  8774350: "86033",
  8774425: "86052",
  8774500: "86022",
  8775000: "97252",
  8775025: "97835",
  8775050: "97801",
  8775075: "97810",
  8775100: "97823",
  8775150: "83520",
  8776000: "85336",
  8776025: "85352",
  8776050: "85347",
  8776075: "85328",
  8776100: "85325",
  8776150: "85344",
  8776200: "86403",
  8776250: "86436",
};